import React, { memo, useCallback } from 'react'
import { Button } from 'src/components/shared/Button'
import tw from 'twin.macro'
import { ChevronLeftMinor } from '@shopify/polaris-icons'
import { CustomerSignContract } from 'src/components/customer/customer-sign-contract/CustomerSignContract'
import { useNavigate } from 'react-router-dom'
import { ROUTES } from 'src/constants/routes'

const CustomerResubmitSignContractPageComponent = () => {
  const navigate = useNavigate()

  const handleBack = useCallback(() => {
    navigate(ROUTES.BASE_URL)
  }, [navigate])

  return (
    <>
      <CustomerSignContract onSubmit={handleBack} />
      <div css={tw`absolute left-4 top-20`}>
        <Button
          onClick={handleBack}
          leftIcon={<ChevronLeftMinor width={20} height={20} fill="white" />}
          size="small"
          color="black"
        >
          Back
        </Button>
      </div>
    </>
  )
}

export const CustomerResubmitSignContractPage = memo(CustomerResubmitSignContractPageComponent)
